// @ts-nocheck
import { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'

import { ErrorBox, HelpLink } from '../generic'
import { colors } from '@lmc/common/constants'
import { ButtonOLD, Text } from '@lmc/ui-kit'
import Glyph from '../../LEGACY/Glyph'

class PopupModal extends Component<any, any> {
  backdrop = null

  handleClose = () => {
    const { close, onClose } = this.props
    close()
    if (onClose) onClose()
  }

  handleBackdropClick = (e) => {
    if (e.target === this.backdrop) this.handleClose()
  }

  setBackdropRef = (element) => {
    this.backdrop = element
  }

  renderHeader = () => {
    const { type, list, title, subtitle, titleDescription } = this.props
    const titleMap = {
      create: `Add a new ${list}`,
      edit: `Edit ${list}`,
    }
    return (
      <div style={styles.headerContainer}>
        <div style={styles.header}>
          <div style={styles.titleWrapper}>
            <Text as="h5" style={styles.title}>
              {title || titleMap[type]}
            </Text>
            {titleDescription && (
              <Text as="h5" style={styles.titleDescription}>
                {titleDescription}
              </Text>
            )}
          </div>

          <div
            className="lmc-action-button"
            id="close-edit-modal"
            onClick={this.handleClose}
            style={styles.closeWrapper}
          >
            <Glyph name="x" size="small" />
          </div>
        </div>
        {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
      </div>
    )
  }

  renderRequiredMessage = () => (
    <div style={styles.required}>
      Required fields are marked with <span style={styles.asterisk}>*</span>
    </div>
  )

  render() {
    const {
      buttonColour,
      buttonDisabled,
      buttonIcon,
      buttonStyle,
      buttonType,
      children,
      confirmText,
      errors,
      includesRequired,
      isSubmitting,
      onConfirm,
      supportArticle,
      helpStyle,
      footerStyle,
      style,
    } = this.props

    // Note that footerStyle can be used to set the justify-content prop of the
    // footer

    return (
      <div style={styles.modalContainer}>
        <div
          style={styles.backdrop}
          ref={this.setBackdropRef}
          onClick={this.handleBackdropClick}
          onTouchEnd={this.handleBackdropClick}
        />
        <div
          className="lmc-popup-modal"
          style={{
            ...styles.wrapper,
            ...style,
            maxHeight: isDesktop ? null : '90%',
            width: !this.props.titleDescription
              ? isDesktop
                ? null
                : '90%'
              : 'max-content',
          }}
        >
          {this.renderHeader()}
          {includesRequired && this.renderRequiredMessage()}
          <ErrorBox errors={errors} style={{ margin: '0px 20px 20px 20px' }} />
          <div style={styles.childWrapper}>{children}</div>
          <div style={{ ...styles.footerContainer, ...footerStyle }}>
            {supportArticle && (
              <HelpLink
                supportLink={supportArticle}
                style={{
                  ...helpStyle,
                  float: 'right',
                  margin: '8px 20px 0px 0px',
                }}
              />
            )}
            <div>
              {/* If a buttonIcon is provided, render using 
                            GlyphButton. Else it'll render the standard button */}
              {buttonIcon ? (
                <ButtonOLD
                  id="popup-modal-primary-action"
                  disabled={isSubmitting || buttonDisabled}
                  onClick={onConfirm}
                  style={{
                    ...styles.saveButton,
                    background: buttonColour,
                    ...buttonStyle,
                  }}
                  icon={<Glyph name={buttonIcon} />}
                  type="primary"
                  data-cy="btn-submit"
                >
                  {confirmText}
                </ButtonOLD>
              ) : (
                <ButtonOLD
                  id="popup-modal-primary-action"
                  disabled={isSubmitting}
                  style={styles.saveButton}
                  onClick={onConfirm}
                  type="primary"
                  dataTestId="next-client-slide"
                >
                  {confirmText || 'Save'}
                </ButtonOLD>
              )}
              <ButtonOLD
                type="secondary"
                id="popup-modal-secondary-action"
                data-cy="btn-cancel"
                onClick={this.handleClose}
                style={styles.cancelButton}
                ghost
              >
                Cancel
              </ButtonOLD>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PopupModal

const isDesktop = isBrowser || isTablet

const styles = {
  asterisk: {
    color: colors.red,
    fontSize: 14,
    fontWeight: 'bold',
  },
  cancelButton: {
    marginRight: 12,
  },
  childWrapper: {
    margin: '0px 20px 20px 20px',
  },
  closeWrapper: {
    cursor: 'pointer',
    transition: 'color .2s ease',
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingLeft: 20,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  backdrop: {
    background: 'black',
    opacity: 0.5,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 100,
  },
  required: {
    bottom: 20,
    color: colors.darkgrey,
    fontSize: 13,
    padding: '0px 20px',
    position: 'relative',
  },
  saveButton: {
    float: 'right',
    color: 'white',
    fontSize: 14,
    padding: '0px 25px',
    textShadow: 'none',
    margin: '0px 20px 20px 25px',
  },
  headerContainer: {
    padding: 20,
  },
  title: {
    fontWeight: 500,
  },
  subtitle: {
    fontSize: 12,
    color: colors.darkgrey,
    paddingTop: 4,
  },
  titleDescription: { marginTop: 0, fontWeight: 500, color: colors.silver },
  modalContainer: {
    minWidth: 200,
  },
  wrapper: {
    background: 'white',
    borderRadius: 10,
    left: '50%',
    maxHeight: 550,
    opacity: 1,
    overflowY: 'auto',
    position: 'fixed',
    top: '50%',
    zIndex: 200,
  },
  titleWrapper: { display: 'flex', flexDirection: 'column' },
}
